import { edpApiV1 } from './index';

export type AuthLoginResponse = {
  token: string;
  tokenTTL: string;
  refreshToken: string;
  refreshTokenTTL: string;
  message: string;
  isNeedChangePassword?: boolean;
  experetionDate?: string;
};
export type AuthLoginPayload = { email: string; password: string };
export type AuthChangePassPayload = { email: string; oldPassword: string; newPassword: string };

export const authApi = edpApiV1.injectEndpoints({
  endpoints: build => ({
    login: build.mutation<AuthLoginResponse, AuthLoginPayload>({
      query: body => ({ url: '/v1/admin/auth/login', method: 'POST', body }),
      invalidatesTags: ['viewer/me'],
    }),
    changePass: build.mutation<AuthLoginResponse, AuthChangePassPayload>({
      query: body => ({ url: '/v1/admin/account/permanent-password', method: 'POST', body }),
      invalidatesTags: ['viewer/me'],
    }),
    logout: build.mutation<void, void>({
      query: () => ({ url: '/v1/admin/auth/logout', method: 'POST' }),
    }),
  }),
  overrideExisting: false,
});

export const { useLoginMutation, useLogoutMutation, useChangePassMutation } = authApi;
